import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import useColumns from "./hooks/useColumns";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import tspsDetalhes from "./components/tspsDetalhes";
import useExcluirAssociacao from "./hooks/useExcluirAssociacao";
import EfisModalInserirAssociacao from "./hooks/EfisModalInserirAssociacao";
import useBuscarAssociacao from "./hooks/useBuscarAssociacao";

const TSPS = ({ dadosOs }) => {
  const [rows, setRows] = useState([]);
  const { request, data, errors, isLoading } = useApiClient();
  const [arquivosSelecionados, setArquivosSelecionados] = useState([]);
  const [showInserirConfirm, setShowInserirConfirm] = useState({
    show: false,
    sqAF: 0,
    arquivosSelecionados: [],
    body: null,
  });

  const { AltAssociacao, setParams } = useBuscarAssociacao();

  const requestDadosOsHandler = useCallback(() => {
    if (dadosOs.acaoFiscal !== "" || dadosOs.acaoFiscal !== undefined) {
      const values = { SqAcaoFiscal: dadosOs.acaoFiscal };

      request(apiRoutes.fiscalizacao.ordemservico.listatsps, values);
    }
  }, [dadosOs, request]);

  const { excluirAssociacao } = useExcluirAssociacao({ onUpdate: requestDadosOsHandler });
  const { columns, columnsAssoc } = useColumns({ excluirAssociacao });

  useEffect(() => {
    requestDadosOsHandler();
  }, [requestDadosOsHandler]);

  useEffect(() => {
    if (data?.result) {
      setRows(data.result || []);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  useEffect(() => {
    setShowInserirConfirm({ show: false });
  }, [setShowInserirConfirm]);

  const preparaAssociar = useCallback(() => {
    if (arquivosSelecionados.length === 1) {
      setShowInserirConfirm({
        show: true,
        sqAF: dadosOs.acaoFiscal,
        arquivosSelecionados: [arquivosSelecionados[0]],
        body: `Informe os campos necessários para preenchimento do TSPS`,
      });
    } else {
      toast.warning("Selecione apenas 1 representante por vez para associar.");
    }
  }, [arquivosSelecionados, dadosOs.acaoFiscal]);

  const alterarAssociar = useCallback(
    (row) => {
      if (row) {
        setParams({
          sqAcaoFiscal: dadosOs.acaoFiscal,
          sqPessoa: row.sqPessoa,
        });

        if (AltAssociacao) {
          setShowInserirConfirm({
            show: true,
            sqAF: dadosOs.acaoFiscal,
            arquivosSelecionados: [AltAssociacao[0]],
            body: `Informe os campos necessários para preenchimento do TSPS`,
          });
        }
      } else {
        toast.warning("Selecione 1 representante para alterar a Associação.");
      }
    },
    [dadosOs.acaoFiscal, setParams, AltAssociacao],
  );

  return (
    <>
      <EfisModalInserirAssociacao
        show={showInserirConfirm.show}
        title={showInserirConfirm.title}
        body={showInserirConfirm.body}
        sqAF={showInserirConfirm.sqAF}
        onUpdate={() => requestDadosOsHandler()}
        arquivosSelecionados={showInserirConfirm.arquivosSelecionados || []}
        closeHandler={() => setShowInserirConfirm({ show: false })}
      />
      <div style={{ width: "100%" }}>
        <Row>
          <Col>
            <h5 style={{ marginBottom: 5 }}>Representante(s) Associado(s)</h5>
            <DataTable
              noHeader
              keyField="codigoExecutor"
              columns={columns}
              data={rows.filter((row) => row.sqAcaoFiscal !== 0)}
              progressPending={isLoading}
              noDataComponent="Não exitem representantes associados."
              progressComponent={<TextSpinner />}
              defaultSortFieldId={1}
              sortIcon={<BsArrowDown />}
              pagination
              paginationServer
              sortable
              paginationTotalRows={rows.filter((row) => row.sqAcaoFiscal !== 0).length}
              selectableRows={false}
              contextMessage={{ singular: "arquivo selecionado", plural: "arquivos selecionados" }}
              onRowClicked={(row) => {
                alterarAssociar(row);
              }}
              pointerOnHover
              paginationPerPage={25}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 50, marginBottom: 50, minWidth: 150 }}>
          <Col>
            <h5 style={{ marginBottom: 25 }}>Associar Representante(s)</h5>
            <DataTable
              noHeader
              keyField=""
              columns={columnsAssoc}
              data={rows.filter(
                (a, i) => rows.findIndex((s) => a.txNmFormal === s.txNmFormal && s.sqAcaoFiscal === 0) === i,
              )}
              progressPending={isLoading}
              noDataComponent="Não exitem representantes sem associação."
              progressComponent={<TextSpinner />}
              defaultSortFieldId={1}
              sortIcon={<BsArrowDown />}
              pagination
              paginationServer
              sortable
              paginationTotalRows={
                rows.filter(
                  (a, i) => rows.findIndex((s) => a.txNmFormal === s.txNmFormal && s.sqAcaoFiscal === 0) === i,
                ).length
              }
              expandableRows
              expandableRowsComponent={(row) => tspsDetalhes({ data, row })}
              pointerOnHover
              selectableRows
              selectableRowsSingle
              onSelectedRowsChange={(state) => {
                setArquivosSelecionados(state.selectedRows);
              }}
              paginationPerPage={25}
            />
            <br style={{ marginTop: 30 }} />
            {arquivosSelecionados.length < 1 && (
              <>
                <span className="alerta" id="alerta">
                  Selecione 1 representante para associar.
                </span>
                <br />
                <br />
              </>
            )}

            <Button
              className="mr-0 btn btn-primary btn-sm btn-user"
              disabled={!arquivosSelecionados.length}
              onClick={() => preparaAssociar()}
            >
              Associar
            </Button>

            <Button
              className="mr-0 btn btn-primary btn-sm btn-user"
              disabled={!arquivosSelecionados.length}
              style={{ marginLeft: "10px" }}
            >
              Associar
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TSPS;
